// src/lib/lead/validation/leadValidation.ts
import type { ExtractedLeadV2 } from "@/types/lead";

export type LeadHeuristicsForValidation = {
  normalizePhone: (s: string) => string;
  isValidEmail: (s: string) => boolean;
};

export function deriveValidationIssues(
  e: ExtractedLeadV2 | null,
  h: LeadHeuristicsForValidation
): string[] {
  if (!e) return ["Missing extracted lead."];

  const issues: string[] = [];

  if (!e.first_name) issues.push("Missing first name.");

  if (!e.phone) {
    issues.push("Missing phone number.");
  } else {
    const digits = h.normalizePhone(e.phone);
    if (digits.length < 10) issues.push("Phone number looks too short (need at least 10 digits).");
  }

  if (e.email && !h.isValidEmail(e.email)) {
    issues.push("Email appears invalid.");
  }

  return issues;
}